export function defaultGetOptionLabel(option, labelKey = 'label', valueKey = 'value') {
  if (option == null) return '';
  if (typeof option === 'string') return option;
  return option[labelKey] ?? option[valueKey] ?? option.name ?? option.label ?? '';
}

export function defaultIsOptionEqualToValue(option, value, valueKey = 'value') {
  if (option === value) return true;
  if (!option || !value) return false;

  const optionId = option.id ?? option[valueKey];
  const valueId = value.id ?? value[valueKey];

  if (optionId != null && valueId != null) {
    return String(optionId) === String(valueId);
  }

  const optionLabel = defaultGetOptionLabel(option, 'label', valueKey);
  const valueLabel = defaultGetOptionLabel(value, 'label', valueKey);
  return optionLabel !== '' && optionLabel === valueLabel;
}

export function dedupeByKey(items = [], getKey = (item) => item?.id) {
  const seen = new Set();
  return items.filter((item) => {
    const key = getKey(item);
    if (key == null || key === '') return true;
    const normalized = String(key);
    if (seen.has(normalized)) return false;
    seen.add(normalized);
    return true;
  });
}

export function injectSelectedOption(options = [], selected, isEqual) {
  if (!selected) return options;
  if (options.some((option) => isEqual(option, selected))) return options;
  return [selected, ...options];
}

export function filterOptionsByQuery(options, query, getOptionLabel) {
  const normalized = String(query ?? '').trim().toLowerCase();
  if (!normalized) return options;

  return options.filter((option) => {
    const label = getOptionLabel(option);
    return String(label ?? '').toLowerCase().includes(normalized);
  });
}

export function computeHasMore({ page, pageSize, itemsLength, totalCount }) {
  if (totalCount != null && !Number.isNaN(Number(totalCount))) {
    return page * pageSize < Number(totalCount);
  }
  return itemsLength >= pageSize;
}

export function mergeSlotProps(base = {}, override = {}) {
  return {
    ...base,
    ...override,
    paper: {
      ...base.paper,
      ...override.paper,
      sx: {
        ...(base.paper?.sx || {}),
        ...(override.paper?.sx || {}),
      },
    },
    listbox: {
      ...base.listbox,
      ...override.listbox,
      sx: {
        ...(base.listbox?.sx || {}),
        ...(override.listbox?.sx || {}),
      },
    },
  };
}
